// Hotfix P1 Orphan Cleanup · redirect table additive · V12 Achromatic Strict.
// -----------------------------------------------------------------------------
// Centralizes all P1-cleanup SPA redirects in one source so App.js stays
// readable. Pattern: array of { from, to, reason } · consumed in App.js
// via `.map()` to produce `<Route Navigate replace />` elements.
//
// Famiglie coperte (vedi /app/memory/orphan_p1_cleanup_plan.md):
//   A · Marketplace V8 legacy  → /app/marketplace (surgical in App.js inline)
//   B · Credits aliases 6 EN   → /app/credits
//   D · Admin leaks /app/admin → /admin canonical
//
// Family C (Events/Rooms) · gestita via nav extensions file separato
// (v12_user_nav_community_extensions.js) · NO redirect, solo nav wire-up.
//
// Note: Family A V8 e Family B /credits + /v2/credits richiedono
// element-replacement in App.js (già registrati con elements custom) ·
// NON possono essere additive via questa tabella. Qui registriamo solo i
// NUOVI redirect (path non ancora registrati in App.js).

export const P1_ORPHAN_REDIRECTS = [
    // --- Family B · Credits aliases (6 nuovi · 2 restanti sono surgical in App.js) ---
    { from: "/wallet",              to: "/app/credits", reason: "EN alias wallet → canonical credits" },
    { from: "/app/wallet",          to: "/app/credits", reason: "EN alias wallet sotto /app" },
    { from: "/billing/credits",     to: "/app/credits", reason: "billing pattern → canonical credits" },
    { from: "/app/billing/credits", to: "/app/credits", reason: "billing pattern sotto /app" },
    { from: "/credits-balance",     to: "/app/credits", reason: "dash-separated alias" },
    { from: "/account/credits",     to: "/app/credits", reason: "account-scoped alias" },

    // --- Family D · Admin leaks /app/admin/* → /admin/* canonical ---
    { from: "/app/admin/dev-toolkit",    to: "/admin/dev-toolkit",    reason: "admin canonical path, no /app/ prefix" },
    { from: "/app/admin/integrations",   to: "/admin/integrations",   reason: "admin canonical path" },
    { from: "/app/admin/kpi",            to: "/admin/kpi",            reason: "admin canonical path" },
    { from: "/app/admin/observability",  to: "/admin/observability",  reason: "admin canonical path" },
];

/** Count of pure-additive redirects (new paths · no App.js collision). */
export const P1_ORPHAN_REDIRECTS_COUNT = P1_ORPHAN_REDIRECTS.length;

/**
 * Surgical replacements NOT in this table (already in App.js with custom
 * elements · require inline element swap to Navigate):
 *   - /credits                                  → /app/credits
 *   - /v2/credits                               → /app/credits
 *   - /marketplace/v8                           → /marketplace/v10  (post hotfix · evita hop via /app/marketplace)
 *   - /marketplace/v8/listings/:listingId       → /marketplace/v10
 *   - /marketplace/v8/listings/by-slug/:slug    → /marketplace/v10
 *   - /marketplace/v8/sellers/:sellerId         → /marketplace/v10
 *   - /marketplace/v8/my-listings               → /marketplace/v10
 *   - /marketplace/v8/my-listings/new           → /marketplace/v10
 *   - /marketplace/v8/my-listings/:listingId/edit → /marketplace/v10
 *   - /marketplace/v8/my-purchases              → /marketplace/v10
 *   - /marketplace/v8/admin/moderation          → /admin/marketplace/v10
 *
 * Documentati per audit · applicati inline in App.js.
 */
export const P1_SURGICAL_REPLACEMENTS = [
    { from: "/credits",      to: "/app/credits",     surgical: true },
    { from: "/v2/credits",   to: "/app/credits",     surgical: true },
    { from: "/marketplace/v8",                                  to: "/marketplace/v10",       surgical: true },
    { from: "/marketplace/v8/listings/:listingId",              to: "/marketplace/v10",       surgical: true },
    { from: "/marketplace/v8/listings/by-slug/:slug",           to: "/marketplace/v10",       surgical: true },
    { from: "/marketplace/v8/sellers/:sellerId",                to: "/marketplace/v10",       surgical: true },
    { from: "/marketplace/v8/my-listings",                      to: "/marketplace/v10",       surgical: true },
    { from: "/marketplace/v8/my-listings/new",                  to: "/marketplace/v10",       surgical: true },
    { from: "/marketplace/v8/my-listings/:listingId/edit",      to: "/marketplace/v10",       surgical: true },
    { from: "/marketplace/v8/my-purchases",                     to: "/marketplace/v10",       surgical: true },
    { from: "/marketplace/v8/admin/moderation",                 to: "/admin/marketplace/v10", surgical: true },
];
